import {NgModule}                         from '@angular/core';
import {BrowserModule}                    from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule}                        from '@ng-bootstrap/ng-bootstrap';
import {routing}                          from './schemas.routing';
import {SchemasComponent}       from './schemas.component';
import {SchemaComponent}        from './components/schema.component';
import {AddSchemaComponent}     from './add.component';
import {EditSchemaComponent}    from './edit.component';
import {CopySchemaComponent}    from './copy.component';
import {ContactMomentComponent} from './components/contact-moments.component';
import {FiltersComponent}       from './components/filters.component';
import {RlTagInputModule}       from 'angular2-tag-input/dist';
import {SharedModule}           from '../shared/shared.module';
import {SchemaCopyModal}        from './schema-copy.modal';
import {SchemasService}         from './schemas.service';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        RlTagInputModule,
        SharedModule,
        NgbModule.forRoot(),
        routing
    ],
    declarations: [
        SchemasComponent,
        SchemaComponent,
        AddSchemaComponent,
        EditSchemaComponent,
        CopySchemaComponent,
        ContactMomentComponent,
        FiltersComponent,
        SchemaCopyModal
    ],
    providers: [
        SchemasService
    ],
    entryComponents: [
        SchemaCopyModal
    ]
})
export class SchemasModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/schemas.module.ts